export default function() {
  return {
    datatables: [],
    lists: [],
    detail: {}
  }
}
